module.exports = __webpack_public_path__ + "static/img/samajuri (10).3c0174b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (10).jpg
// module id = UEH5
// module chunks = 0